import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login, apiError } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Sesión iniciada");
      navigate(u.role === "admin" ? "/admin" : "/agenda");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#373E45] p-12">
        <Link to="/" data-testid="login-logo-dark-link" className="self-start"><Logo variant="dark" className="h-9" /></Link>
        <div>
          <h2 className="text-3xl font-bold text-white leading-tight">Tu agenda de ecografías,<br />siempre a mano.</h2>
          <p className="mt-4 text-slate-300 max-w-md">Accede para consultar la disponibilidad y gestionar las citas de tu clínica.</p>
        </div>
        <p className="text-slate-400 text-sm">© {new Date().getFullYear()} Veteo</p>
      </div>

      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Link to="/" data-testid="login-logo-link"><Logo className="h-10" /></Link></div>
          <h1 className="text-2xl font-extrabold text-[#373E45]">Iniciar sesión</h1>
          <p className="text-[#64748B] text-sm mt-1 mb-8">Accede al panel de tu clínica.</p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-[#373E45] font-semibold">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 bg-slate-50 focus-visible:ring-[#7FD498]" placeholder="clinica@email.com" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-[#373E45] font-semibold">Contraseña</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 bg-slate-50 focus-visible:ring-[#7FD498]" placeholder="••••••••" data-testid="login-password-input" />
              <div className="mt-1.5 text-right">
                <Link to="/forgot-password" className="text-sm font-semibold text-[#64748B] hover:text-[#373E45] hover:underline" data-testid="forgot-password-link">¿Olvidaste tu contraseña?</Link>
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#7FD498] hover:bg-[#6BC284] text-[#373E45] font-bold rounded-xl h-11" data-testid="login-submit-btn">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar"}
            </Button>
          </form>
          <p className="text-sm text-[#64748B] mt-6 text-center">
            ¿No tienes cuenta?{" "}
            <Link to="/register" className="text-[#373E45] font-bold hover:underline" data-testid="goto-register-link">Registra tu clínica</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
